import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import { Link } from "react-router-dom";
const Aprofitdownline = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />

      <div className="commision bg-[#f0ece1] fixed_width h-[100vh]  ">
        <div className="px-[100px]">
          <h2 className="font-bold text-black py-2 ">
            Profit/Loss Report by Downline
          </h2>
          <label htmlFor="" className="mr-3">
            Data source:
          </label>
          <select name="" className="w-[120px] text-[20px]">
            <option value="" className="">
              DB
            </option>

            <option value="">ELK</option>
          </select>
        </div>
        <div className="   justify-center flex  ml-4  ">
          <div className="bg-[#dff1f8] mt-2 w-[90%]">
            <div className=" mt-2 px-3 py-2 flex">
              <div className="flex items-center">
                <p className="text-[12px] ml-3">Period</p>
                <input
                  type="date"
                  className="mx-2 py-1 px-2 border-gray-400 border-1 "
                  id="birthday"
                  name="birthday"
                ></input>
                <input
                  type="text"
                  className="w-[60px] py-1 border-1 border-gray-400"
                  placeholder="9:00"
                />
                <p className="">To</p>
                <input
                  type="date"
                  className="mx-2 py-1 px-2 border-gray-400 border-1 "
                ></input>
                <input
                  type="text"
                  className="py-1 w-[60px] border-1 border-gray-400"
                  placeholder="9:00"
                />
              </div>
            </div>
            <div className="ml-4 pb-3">
              <button
                className="text-[12px]  border-gray-400 border-1  rounded px-3 py-1 mt-2 font-medium
            bg-[#fff]
        "
              >
                Just For Today
              </button>
              <button
                className="text-[12px]  border-gray-400 border-1  py-1 mx-1 rounded px-3 mt-2 font-medium
            bg-[#fff]
        "
              >
                Just For Today
              </button>
              <button
                className="text-[12px]  border-gray-400 border-1  py-1 mx-1 rounded px-3 mt-2 font-bold
            bg-[#ffaa50] w-[120px]
        "
              >
                Get Matches
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aprofitdownline;
